import {useSelector} from 'react-redux';

function useCurrentClientLogos() {
  const logos = useSelector((state) => state.session.logos);

  const getLogoUrl = (scope) => {
    if (scope && logos?.length > 0) {
      return logos?.find((logo) => logo?.scopes?.includes(scope))?.logoUrl;
    }
  };

  return {
    getLogoUrl,
  };
}

export default useCurrentClientLogos;
